$(document).ready(function() {
  /* var tabs = $('ul.tabs > li > a');
  tabs.each(function(i) {
    jQuery(this).unbind('click.smoothscroll').click(function(e) {
      e.preventDefault();
      var contentLocation = $(this).attr('href');
    	if(contentLocation.charAt(0)=="#") {            
  			tabs.removeClass('active');
  			$(this).addClass('active');
  			$(contentLocation).show().addClass('active').siblings().hide().removeClass('active');
    	 }
      return false;
    });
  }); */
  $("a.ui-tabs-anchor").click(function (e) {
    e.preventDefault();
    // sole.log("this is %o, event is %o, host is %s", this, e, location.host);
    return false;
  });
  
  $(".search-bar").focus(function(){
  
    $(".header-search__wrapper_custom").addClass("mobile-header-move");
  
  })
  
  $(".search-bar").blur(function(){
  
    $(".header-search__wrapper_custom").removeClass("mobile-header-move");
  
  })
  
  
  // add div for video
  $(".product-yt .yt-tabs").wrap("<div class='overflow-tab' />");
  
});